
export class AppInfo {
    id: string;
    name: string;
    url?: string;
    endpoint?: string;
    features?: string[];
    apps?: { [key: string]: string };

}

export class SessionService {
    static APPS: AppInfo[] = [
        {
            id: 'thinkteams',
            name: 'ThinkTeams',
            features: [
                'feature_service',
                'feature_manual_occupancy',
                'feature_property_manage',
                'feature_hr',
                'feature_task',
                'feature_training',
                'feature_performance'

            ]
        },
        {
            id: 'thinkspots',
            name: 'ThinkSpots',
            features: [
                'feature_screen',
                'feature_stock',

            ]
        },
        {
            id: 'thinkshops',
            name: 'ThinkShops',
            apps: {
                ios: 'https://apps.apple.com/us/app/thinkshops/id1572786520',
                android: 'https://play.google.com/store/apps/details?id=com.thinkretail.thinkshops'
            },
            features: [
                'feature_commerce',
                'feature_site',
                'feature_food',
                'feature_queue',


            ]
        },
    ]


    static fixTitle(app: string) {
        if (!app) return;
        switch (app) {
            case 'thinkshops':
                document.title = 'ThinkShops';
                break;
            case 'thinkteams':
                document.title = 'ThinkTeams';
                break;
            case 'thinkspots':
                document.title = 'ThinkpSpots';
                break;
        }

    }
}